import React from 'react';
import { useTranslation } from 'react-i18next';

import ReturnsContainer from '../ReturnsContainer';
import StickyPageHeader from '../../common2/StickyPageHeader/StickyPageHeader';
import ReturnsTranslationsSteps from './ReturnsTranslationsSteps';
import ReturnPortalTranslationsPreview from './ReturnPortalTranslationsPreview';
import Button from '../../common2/Button';
import Show from '../../common2/Show';
import Loader from '../../common/Loader';
import useShopReturnPortalsTranslations from './useShopReturnPortalsTranslations';
import useSelectedShop from '../../../hooks/useSelectedShop';
import useUnload from '../../../hooks/useUnload';
import usePrompt from '../../../hooks/usePrompt';

import LiveIcon from '../../../icons/check-circle-filled.svg';

import './ReturnsTranslationsPage.scss';

function ReturnsTranslationsPage(props) {
  const { id, isReturnPortalLite: isLite } = useSelectedShop();
  const { t } = useTranslation();

  const {
    translations,
    templateTranslations,
    changeTranslations,
    isChanged,
    publishTranslations,
    isPublishing,
    resetTranslations,
  } = useShopReturnPortalsTranslations(id);

  useUnload(isChanged);
  usePrompt(isChanged, t('RPTP_EXIT_MODAL_MESSAGE'));

  return (
    <ReturnsContainer {...props}>
      <StickyPageHeader title="Translations">
        <Button
          intent="success"
          icon={LiveIcon}
          disabled={!isChanged}
          isLoading={isPublishing}
          onClick={publishTranslations}
        >
          Publish translations
        </Button>
      </StickyPageHeader>
      <Show when={!!templateTranslations} fallback={<Loader />}>
        <div styleName="content">
          <ReturnsTranslationsSteps
            templateTranslations={templateTranslations}
            onChange={changeTranslations}
            onResetTranslations={resetTranslations}
          />
          <ReturnPortalTranslationsPreview translations={translations} isLite={isLite} />
        </div>
      </Show>
    </ReturnsContainer>
  );
}

export default React.memo(ReturnsTranslationsPage);
